/// <amd-module name="Feed/Core/Redux/Navigation/FeedNavigationModule" />
import { ISagaModule } from "redux-dynamic-modules-saga";

import { IFeedNavigationAwareState } from "./NavigationContracts";
import { navigationReducer } from "./NavigationReducers";
import rootSaga from "./NavigationSagas";

export const FeedNavigationModule: ISagaModule<IFeedNavigationAwareState> = {
    id: "feed-navigation",
    reducerMap: {
        navigation: navigationReducer
    },
    sagas: [rootSaga]
};

export const getFeedNavigationModule = () => FeedNavigationModule;
